<template>
<div class="chapter">
<div class="inner_page">
<div class="booksection">
<p class="chap1">AM</p>
<p class="chap_line"></p>
<p class="center"><span class="big">W</span>ithout exception every culture has role models, both good and bad, that are a template that your children choose to use to copy as close as they can</p>
<p class="center">And we are no exception to those values as children we also chose, only now as a parent can we understand the price we paid for acts unwittingly planned, and the perfect role model was only one prayer away for the answer to “who would you copy in exact detail”</p>
<p class="center">was explicitly answered when our Lord and Savior admonished, “What manner of man aught you be” and answered, “Even as I am.”</p>
<p class="center1">His entire stewardship here was in service to all of mankind</p>
<p class="center">And his plan of redemption that God the Father chose mandated he pay the entire price so that not even one soul would be left behind.</p>
<p class="center1">His perfect example of how you should follow and be a true servant of God in service to all of mankind as your Lord and Savior was here</p>
<p class="center">And with a perfect understanding that your stewardship and service will continue on the other side of the veil to ensure that every soul ever born will the word of God the Father hear.</p>
<p class="center1">There are sacred ordinances that can only be performed in the temples on this side of the veil And you will be held accountable if in this important work you shirk and fail.</p>
<p class="center1">The values espoused by Christ have no basis in person or gender</p>
<p class="center">But are absolute truths for every soul to follow and remember.</p>
<p class="center1">There is not one second in your entire life that will not be examined in the bright light of righteousness and with the light of Christ shining from your soul through your eyes and face</p>
<p class="center">For only those eternal mates with spotless robes free from any kind of sin will be allowed in hallowed halls of the Celestial Kingdom to kneel at God’s throne with unending love and grace.</p>
<p class="center1">Without exception every culture has role models, both good and bad, that are a template that your children choose to use to copy as close as they can</p>
<p class="center">And we are no exception to those values as children we also chose, only now as a parent can we understand the price we paid for acts unwittingly planned, and the perfect role model was only one prayer away for the answer to “who would you copy in exact detail”</p>
<p class="center">was explicitly answered when our Lord and Savior admonished, “What manner of man aught you be” and answered, “Even as I am.”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chap008.vue?03bbd2ca